<template>



    <button class="button-auth--facebook d-flex align-center justify-center rounded-pill" @click="fbLogin">
        
        <facebook-white class="button-auth__icon"></facebook-white>
        <p class="button-auth__text">{{ buttonText }}</p>
        
    </button>





</template>



<script>

import { computed } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import { useSnackbar } from '@/composables/useSnackbar';
import FacebookWhite from "@/icons/FacebookWhite.vue";

/* global FB */

export default {
    name: "SigninWithGoogleButton",
    components: {
        FacebookWhite,
    },
    props: {
        action: {
            type: String,
            required: true,
            default: 'signin',
            validator: value => ['signin', 'signup'].includes(value)
        }
    },
    setup(props) {

        const { showSnackbar } = useSnackbar();
        const authStore = useAuthStore();

        const fbLogin = () => {
            FB.login(
                (response) => {
                    if (response.authResponse) {
                        const accessToken = response.authResponse.accessToken;
                        FB.api(
                            "/me/permissions",
                            { access_token: accessToken },
                            (permsResponse) => {
                                const hasEmailPermission = permsResponse.data.some(
                                    (perm) =>
                                        perm.permission === "email" && perm.status === "granted"
                                );
                                if (hasEmailPermission) {
                                    authStore.facebookLoginResponse = response;
                                } else {
                                    showSnackbar({
                                        message: "Email permission not granted",
                                        color: "error",
                                    });
                                }
                            }
                        );
                    } else {
                        showSnackbar({
                            message: "Login Failed",
                            color: "error",
                        });
                    }
                },
                {
                    scope: "email",
                }
            );
        };


        const buttonText = computed(() => {
            return props.action === 'signin' ? 'Sign in with Facebook' : 'Sign up with Facebook';
        });


        return {
            fbLogin,
            buttonText,
        };
    }
};
</script>